<template>
  <div class="install-channels">
    <div
      v-for="item in installChannels"
      :key="item.imgSrc.value"
      class="install-cha"
      @click="handleChaClick(item)"
    >
      <a
        :href="item.href"
        :style="{ 'background-image': `url(${item.imgSrc.value || ''})` }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { InstallChannels } from '@/composables/useInstallChannels'

interface Props {
  installChannels: InstallChannels
  onClick?: (channel: InstallChannels[0]) => void
}

const props = defineProps<Props>()

const handleChaClick = (channel: InstallChannels[0]) => {
  if (channel.trackEventButtonParameter !== 'google') {
    navigator.clipboard.writeText(window.location.href || '')
  }
  props.onClick?.(channel)
}
</script>

<style lang="less" scoped>
.install-cha {
  width: 168px;
  height: 48px;
  margin: 0 auto 12px;
  border-radius: 4px;

  > a {
    display: block;
    width: 100%;
    height: 100%;
    background-size: cover;
  }
}
</style>
